import React from 'react';
import { Modal } from 'react-bootstrap';
import { ImageBrokenKey } from '../../assets/images';
import { TranslationUtils, ValidationUtils } from '../../utils';
import { Button } from '../Button/Button';
import './ReservationCancelledModal.scss';
import { useSelector } from 'react-redux';
import { StoreState } from '../../types/store.type';

export const ReservationCancelledModal: React.FC = (props) => {
    const myTripsUrl = ValidationUtils.validateAndGetEnvVar('REACT_APP_MY_TRIPS_URL');
    const { isCancelled, tripProtectionMessage } = useSelector((state: StoreState) => state.trip);

    const handleMyTripsRedirect = () => {
        window.location.replace(myTripsUrl);
    };

    return (
        <Modal id={'error-modal'} backdropClassName={'custom-modal-backdrop'} show={isCancelled}>
            <Modal.Header />
            <Modal.Body className={'error-modal-body'}>
                <br />
                <br />
                <ImageBrokenKey className="cancel-modal-image" />
                <div className="error-modal-instructions">
                    <br />
                    <h4 className={'heading-med-light'}>{TranslationUtils.get('modal_cancel_title')}</h4>
                    <div className="mb-2" />

                    <p className={'body-regular'}>{TranslationUtils.get('modal_cancel_note')}</p>
                    <div className="mb-2" />
                    <p>{tripProtectionMessage}</p>
                </div>

                <div className="early-checkout-modal-buttons">
                    <a
                        className={'body-regular'}
                        aria-label={`${TranslationUtils.get('modal_cancel_go_to_my_trips')}`}
                        href={myTripsUrl}
                        target="_blank"
                    >
                        <Button
                            id="button-cancel-checkout"
                            className="body-regular cancel-action-button"
                            onClick={handleMyTripsRedirect}
                            label={TranslationUtils.get('modal_cancel_go_to_my_trips')}
                            variant="primary"
                            block
                        />
                    </a>
                </div>
            </Modal.Body>
        </Modal>
    );
};
